// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2khdb","head":"ProcedureTableInfo_head__rPS37"};